import React from 'react';
import EmailQuote from 'pu-react/components/EmailQuote'
import CustomEmailQuote from './CustomEmailQuote'

const EmailProjectQuote = (props) => (
  <div className="btn-action-project email-project-quote col">
    <CustomEmailQuote {...props} />
  </div>
)

export default EmailProjectQuote;
